<template>
    <div class="h-100 d-flex align-center justify-center">
        <v-card max-width="400px">
            <v-card-title>
                Descargar Resultados
            </v-card-title>

            <v-card-text class="d-flex flex-column ga-2">
                <p>
                    Presionando el botón "Descargar" podrás generar y descargar un archivo
                    excel con los resultados de todas las encuestas realizadas por este
                    sistema.
                </p>
                <v-alert
                    v-if="isDownloaded"
                    type="success"
                    dense
                    dismissible
                    border="start"
                    icon="mdi-check"
                    variant="tonal"
                >
                    Archivo descargado correctamente. Revise su carpeta de descargas.
                </v-alert>
                <v-alert
                    v-else-if="hasError"
                    type="error"
                    dense
                    dismissible
                    border="start"
                    icon="mdi-alert"
                    variant="tonal"
                >
                    Ha ocurrido un error al intentar descargar el archivo. Por favor, inténtelo
                    nuevamente. Si el error persiste, contacte al administrador del sistema.
                </v-alert>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    color="primary"
                    @click="downloadResults"
                    prepend-icon="mdi-download"
                    :loading="downloadingResults"
                    block
                >
                    Descargar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script setup lang="ts">
import { ExcelGeneratorService } from '@/services/excel-generator/excelGeneratorService';
import { ref } from 'vue';

const excelGeneratorService = new ExcelGeneratorService();
const downloadingResults = ref(false)
const isDownloaded = ref(false)
const hasError = ref(false)

async function downloadResults() {
    isDownloaded.value = false
    hasError.value = false

    downloadingResults.value = true
    const response = await excelGeneratorService.downloadExcelFile()
    downloadingResults.value = false

    console.log(response);
    
    if (response) {
        isDownloaded.value = true
    } else {
        hasError.value = true
    }
}
</script>